import React, { useState } from "react";
import PageShell from "../dashboard/PageShell";
import {
  ProjectBasicInfo,
  ProjectMembers,
  ProjectAdditionalContent,
  ProjectFormActions,
} from "../../components/forms/ProjectForm";
import RichTextEditor from "../../components/forms/RichTextEditor";

interface AddNewProjectProps {}

const AddNewProject: React.FC<AddNewProjectProps> = () => {
  const [activeTab, setActiveTab] = useState("topic-info");
  const [formData, setFormData] = useState({
    topicName: "",
    managementLevel: "",
    managementLevelInput: "",
    provinceCity: "",
    researchField: "",
    specificProgram: "",
    proposedBudget: "",
    leadUnit: "",
    leadUnitInput: "",
    governingUnit: "",
    otherGoverningUnit: "",
    startMonth: "",
    startYear: "",
    endMonth: "",
    endYear: "",
    contractingMethod: "",
    topicChair: "",
    chairName: "",
    chairGender: "",
    chairAcademicTitle: "",
    chairAcademicDegree: "",
    chairResearchTitle: "",
    chairRank: "",
    chairWorkUnit: "",
    topicSecretary: "",
    secretaryName: "",
    secretaryGender: "",
    secretaryAcademicTitle: "",
    secretaryAcademicDegree: "",
    secretaryResearchTitle: "",
    secretaryRank: "",
    secretaryWorkUnit: "",
    objective: "",
    topicType: "",
    urgencyAndNovelty: "",
    mainContents: "",
    applicationCapability: "",
    expectedBenefits: "",
    expectedResults: "",
    topicStatus: "",
  });

  const handleInputChange = (field: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    console.log("Saving project data:", formData);
    // TODO: Implement save functionality
  };

  return (
    <PageShell title="Thêm dự án mới">
      <div className="space-y-6">
        {/* Header Section */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Thêm dự án mới
          </h1>
        </div>

        {/* Tabs Section */}
        <div className="bg-white rounded-lg">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8 px-6">
              <button
                onClick={() => setActiveTab("topic-info")}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === "topic-info"
                    ? "border-[#337ab7] text-[#337ab7]"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
              >
                Thông tin đề tài
              </button>
              <button
                onClick={() => setActiveTab("full-content")}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === "full-content"
                    ? "border-[#337ab7] text-[#337ab7]"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
              >
                Nội dung đầy đủ
              </button>
            </nav>
          </div>

          {/* Tab Content */}
          <div className="p-6">
            {activeTab === "topic-info" && (
              <div className="space-y-8">
                {/* Top Field - Full Width */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Tên đề tài <span className="text-red-500">(*)</span>
                  </label>
                  <input
                    type="text"
                    value={formData.topicName}
                    onChange={(e) =>
                      handleInputChange("topicName", e.target.value)
                    }
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Nhập tên đề tài..."
                  />
                </div>

                <ProjectBasicInfo
                  formData={formData}
                  handleInputChange={handleInputChange}
                />

                <ProjectMembers
                  formData={formData}
                  handleInputChange={handleInputChange}
                />

                <ProjectAdditionalContent
                  formData={formData}
                  handleInputChange={handleInputChange}
                />
              </div>
            )}

            {activeTab === "full-content" && (
              <div className="space-y-8">
                {/* Rich Text Editor Section */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Kết quả dự kiến:
                  </label>
                  <RichTextEditor
                    value={formData.expectedResults || ""}
                    onChange={(value: string) =>
                      handleInputChange("expectedResults", value)
                    }
                    placeholder="Nhập nội dung kết quả dự kiến..."
                    height="large"
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <ProjectFormActions
          onSave={handleSave}
          onCancel={() => window.history.back()}
        />
      </div>
    </PageShell>
  );
};

export default AddNewProject;
